export const ASC = "ASC"; //По возрастанию
export const DESC = "DESC"; //По убыванию
